import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "templates-picker__list"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcTextField = _resolveComponent("NcTextField")
  const _component_NewMessageTemplatePreview = _resolveComponent("NewMessageTemplatePreview")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_NcDialog = _resolveComponent("NcDialog")

  return (_openBlock(), _createBlock(_component_NcDialog, {
    name: $options.t('spreed', 'Create and share a new file'),
    size: "large",
    class: "templates-picker",
    "close-on-click-outside": "",
    "onUpdate:open": $options.closeModal
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_NcButton, {
        variant: "primary",
        disabled: $data.loading || !!$data.newFileError,
        onClick: $options.handleCreateNewFile
      }, _createSlots({
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Create file')), 1)
        ]),
        _: 2
      }, [
        ($data.loading)
          ? {
              name: "icon",
              fn: _withCtx(() => [
                _createVNode(_component_NcLoadingIcon)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "templates-picker__form",
        style: _normalizeStyle($options.style),
        onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.handleCreateNewFile && $options.handleCreateNewFile(...args)), ["prevent"]))
      }, [
        _createVNode(_component_NcTextField, {
          id: "new-file-form-name",
          ref: "textField",
          modelValue: $data.newFileTitle,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.newFileTitle) = $event)),
          error: !!$data.newFileError,
          "helper-text": $data.newFileError,
          label: $options.t('spreed', 'Name of the new file'),
          placeholder: $data.newFileTitle
        }, null, 8, ["modelValue", "error", "helper-text", "label", "placeholder"]),
        ($options.templates.length > 1)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.templates, (template) => {
                return (_openBlock(), _createBlock(_component_NewMessageTemplatePreview, {
                  key: template.fileid,
                  basename: template.basename,
                  checked: $data.checked === template.fileid,
                  fileid: template.fileid,
                  filename: template.filename,
                  "preview-url": template.previewUrl,
                  "has-preview": template.hasPreview,
                  mime: template.mime,
                  ratio: $options.fileTemplate.ratio,
                  onCheck: $options.onCheck
                }, null, 8, ["basename", "checked", "fileid", "filename", "preview-url", "has-preview", "mime", "ratio", "onCheck"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 36)
    ]),
    _: 1
  }, 8, ["name", "onUpdate:open"]))
}